import { Grid } from '@mui/material';
import { HSpacer, RoutalPalette } from '@nx-smartmonkey/ui';

import BadOrder from '../../../assets/svg/drivers-survey-rating-tags/BadOrder';
import ClientAngry from '../../../assets/svg/drivers-survey-rating-tags/ClientAngry';
import ClientHappy from '../../../assets/svg/drivers-survey-rating-tags/ClientHappy';
import CorrectDirection from '../../../assets/svg/drivers-survey-rating-tags/CorrectDirection';
import GoodOrder from '../../../assets/svg/drivers-survey-rating-tags/GoodOrder';
import LoveRoute from '../../../assets/svg/drivers-survey-rating-tags/LoveRoute';
import MuchWork from '../../../assets/svg/drivers-survey-rating-tags/MuchWork';
import WrongDirection from '../../../assets/svg/drivers-survey-rating-tags/WrongDirection';
import { DriversSurvey, RatingTags } from '../../../domain/driversSurvey/DriversSurvey';
import Text from '../../../react-components/Text';

export const getSurveyRatingIcon = ({ rating = 0, ratingTag }: { rating?: number; ratingTag?: RatingTags }) => {
  const isBad = rating <= 2;
  switch (ratingTag) {
    case `workload`:
      return isBad ? MuchWork : LoveRoute;
    case `address_data`:
      return isBad ? WrongDirection : CorrectDirection;
    case `customer_experience`:
      return isBad ? ClientAngry : ClientHappy;
    case `stops_order`:
      return isBad ? BadOrder : GoodOrder;
    default:
      return null;
  }
};

export const getSurveyRatingTagText = ({
  rating = 0,
  ratingTag,
}: {
  rating?: number;
  ratingTag?: RatingTags;
}): string => {
  const isBad = rating <= 2;
  return ratingTag ? `properties.route.survey.rating_tag.${isBad ? `bad` : `good`}.${ratingTag}` : ``;
};

export const getSurveyRatingTagInfo = (survey: DriversSurvey) => {
  const RatingTagIcon = getSurveyRatingIcon({ rating: survey.rating, ratingTag: survey.rating_tag });
  const ratingTagIntlId = getSurveyRatingTagText({ rating: survey.rating, ratingTag: survey.rating_tag });

  if (!RatingTagIcon) return null;

  return (
    <Grid container direction="row" alignItems="center">
      <RatingTagIcon style={{ width: `24px`, color: `${RoutalPalette.secondary40}` }} />
      <HSpacer small />
      <Text intlId={ratingTagIntlId} />
    </Grid>
  );
};
